 const BASE_URL = "https://otc-api.dolidol.ma/api";
// const BASE_URL = "https://dolidol-otc-api-prod.azurewebsites.net/api";
// const BASE_URL = "https://dolidol-otc-api-representant.azurewebsites.net/api";

const endpoints = {
  baseURL: BASE_URL,
  commandes: {
    commandesParClient: `${BASE_URL}/Orders/ordersByClient`,
    commandesParRepresentant: `${BASE_URL}/Representant/GetCommandeListByRepresantant`,
    detailCommandeParClient: `${BASE_URL}/Orders/orderDetails/`,
    precommandeList: `${BASE_URL}/Representant/GetPrecommandeList`,
    SavePrecommandeByRepresenatant : `${BASE_URL}/Precommande/SavePrecommandeByRepresenatant`
  },
  infosClient: {
    infosClientDetail: `${BASE_URL}/Client/ClientInfo`,
    downloadReleve: `${BASE_URL}/Representant/Relever/`,
    represenatantClientDetails: `${BASE_URL}/Representant/RepresenatantClientDetails`,
  },
  login: {
    authenticateUser: `${BASE_URL}/Authenticate/login`,
    refreshToken: `${BASE_URL}/Authenticate/refresh-token`
  },
  restePassword: {
    resteUserPassword : `${BASE_URL}/Authenticate/reste-password`
  },
  changePassword: {
    changeUserPassword: `${BASE_URL}/Authenticate/change-password`,
  },
  sites: {
    allSites: `${BASE_URL}/Sites/allSites`,
    mySites: `${BASE_URL}/Sites/mySites`,
  },
  administration: {
    representants: `${BASE_URL}/Administration/representants`,
    sageRepresentants: `${BASE_URL}/Administration/sage-representants`,
    representantSites: (userId: string) =>
      `${BASE_URL}/Administration/representants/${encodeURIComponent(userId)}/sites`,
    representantStatus: (userId: string) =>
      `${BASE_URL}/Administration/representants/${encodeURIComponent(userId)}/status`,
  },
  clients: {
    clientsBySalesRepresentative: `${BASE_URL}/Representant/ClientsParRepresentant`,
  },
  articles: {
    getScenario: `${BASE_URL}/Articles/GetScenario/`,
    saveSpecialArticle: `${BASE_URL}/Articles/SaveSageArticle`,
    updateData: `${BASE_URL}/ConditionsConfigurateur/GetNewFormData`,
    getArticlesStandard:`${BASE_URL}/Articles/GetArticles`,
    articleTarif:`${BASE_URL}/Articles/GetArticleTarif`
  },
  objectif: {
    getObjectives: `${BASE_URL}/Objectifs/listeObjectifs`,
    deleteObjectif: `${BASE_URL}/Objectifs/deletObjectif`,
    listRepresentants: `${BASE_URL}/Objectifs/ListRepresentants`,
    createObjectif: `${BASE_URL}/Objectifs/CreateObjectif`
  },
  preOrders:{
    preOrderDetail:`${BASE_URL}/Precommande/PrecommandesDetails/`,
    precommandeList:`${BASE_URL}/Precommande/PrecommandeList`,
    updateStatut:`${BASE_URL}/Precommande/UpdateStatut`
  }
};

export default endpoints;
